import { render, staticRenderFns } from "./CourseLevel.vue?vue&type=template&id=1cbdf52f"
import script from "./CourseLevel.vue?vue&type=script&lang=js"
export * from "./CourseLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cbdf52f')) {
      api.createRecord('1cbdf52f', component.options)
    } else {
      api.reload('1cbdf52f', component.options)
    }
    module.hot.accept("./CourseLevel.vue?vue&type=template&id=1cbdf52f", function () {
      api.rerender('1cbdf52f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/CourseLevel.vue"
export default component.exports